/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Alert, Badge, Divider, Grid, Group, Paper, Select, Space, Stack } from '@mantine/core';
import { IconAlertTriangle, IconZoomMoney } from '@tabler/icons-react';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { ReferenciaCodigo, Status, TipoCodigo } from '../../../../../business/events/general';
import PageSection from '../../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../../components/core/PageViewProperty/PageViewProperty';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { useEventGeneralContext } from '../../../../../contexts/core/events/EventGeneral.context';
import { EntityTypeType, UnitOfMeasureType } from '../../../../../models/core/cache.type';
import { EventType } from '../../../../../models/core/events.type';
import { Feature, SessionStorageKey } from '../../../../../utils/constants.utils';
import { formatCurrency } from '../../../../../utils/formatter.utils';
import { buildFakeAuditObject, newGuid } from '../../../../../utils/helper.utils';
// import { QuotationSelectItem } from './PlanQuotationSelectItem/PlanQuotationSelectItem';
import { ProposalResiduePlanCodeEnum } from '../../../../../models/core/proposals.type';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../../../utils/mantine.utils';
import EventResidueReferenceEditor from '../../components/EventResidueReferenceEditor';
import { buildSelectQuotationItem } from './PlanQuotationSelectItem/PlanQuotationSelectItem';
import EventServiceFormView from './ReferenceFormView/Service/EventServiceFormView';

type EventFormViewProps = {
  referenceData: { entityTypeData: EntityTypeType[]; unitOfMeasures: UnitOfMeasureType[] };
  event: EventType | null;
  zIndex: number;
};

const ReferenceFormView = forwardRef((props: EventFormViewProps, ref) => {
  const { eventGeneralData, setEventGeneralData } = useEventGeneralContext();
  const refResidueReferenceEditor = useRef<any>();
  const refServiceForm = useRef<any>();

  const [quotationId, setQuotationId] = useState<number | null>(null);
  const [autoImportedMissingSupplier] = useState(false);

  const tempEvento = JSON.parse(sessionStorage.getItem(SessionStorageKey.TempEvent) || 'null');
  const shouldUseTempEvento = !props.event && tempEvento && !eventGeneralData.idEventoReferencia2;
  const evento = shouldUseTempEvento
    ? {
        ...tempEvento,
        idEvento: undefined,
        codigoEventoReferencia:
          tempEvento.codigoEventoTipo === TipoCodigo.Lembrete ? null : tempEvento.codigoEventoReferencia,
        idEventoReferencia1:
          tempEvento.codigoEventoTipo === TipoCodigo.Lembrete ? null : tempEvento.idEventoReferencia1,
        idEventoReferencia2: '-999', // set '-1' to import as 'Other'
        idEventoReferencia3: null,
        automatico: false,
      }
    : props.event;

  const statusSoftDisabled = evento
    ? evento.codigoEventoStatus === Status.PendenteFaturamento ||
      evento.codigoEventoStatus === Status.PendenteMedicao ||
      (evento.idEventoVeiculoCompartilhado && evento.resumoJSON.veiculoCompartilhado)
    : false;

  const clienteLocalData =
    eventGeneralData.propostaResiduoData || eventGeneralData.propostaServicoData || null;

  const documentoValido = () => {
    return eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.EntidadeDocumento;
  };

  const comissaoValida = () => {
    return eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoComissao;
  };

  const residuoValido = () => {
    return (
      (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
        eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
        eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) &&
      eventGeneralData.propostaResiduoData &&
      (eventGeneralData.idEventoReferencia2 || eventGeneralData.eventoReferenciaPersonalizado)
    );
  };

  const servicoValido = () => {
    return (
      eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoServico &&
      (!!eventGeneralData.propostaServicoData || !!evento?.servico || !!evento?.referencia?.contrato?.servico)
    );
  };

  const clienteLocalValido = () => {
    return (
      eventGeneralData.codigoEventoReferencia &&
      ((eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoServico &&
        eventGeneralData.propostaServicoData) ||
        ((eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) &&
          eventGeneralData.propostaResiduoData)) &&
      clienteLocalData
    );
  };
  const propostaContato = clienteLocalValido() ? evento?.referencia?.contrato.proposta || null : null;

  const encontrarPlanoRegularBase = (residuo: any) => {
    return (
      residuo?.planos?.find(
        (x: any) => x.codigoPlanoTipo === ProposalResiduePlanCodeEnum.Regular && x.primario
      ) ||
      residuo?.planos?.find((x: any) => x.codigoPlanoTipo === ProposalResiduePlanCodeEnum.Regular) ||
      residuo?.planos?.find((x: any) => x.primario) ||
      residuo?.planos?.[0] ||
      null
    );
  };

  const encontrarPlanoCotacao = () => {
    const residuo = eventGeneralData.propostaResiduoData;
    if (!residuo) {
      return {};
    }

    let planoInicial;
    let planoCotacaoInicial;

    if (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento) {
      for (const plano of residuo.planos) {
        if (
          plano.acondicionamentos.findIndex(
            (x) => x.idPropostaResiduoPlanoAcondicionamento === eventGeneralData.idEventoReferencia2
          ) > -1
        ) {
          planoInicial = plano;
          for (const cotacao of planoInicial.cotacoes) {
            if (
              cotacao.acondicionamentos.findIndex(
                (x) => x.idPropostaResiduoPlanoAcondicionamento === eventGeneralData.idEventoReferencia2
              ) > -1
            ) {
              planoCotacaoInicial = cotacao;
              break;
            }
          }
        }
        if (planoInicial && planoCotacaoInicial) {
          break;
        }
      }
    } else if (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento) {
      for (const plano of residuo.planos) {
        if (
          plano.equipamentos.findIndex(
            (x) => x.idPropostaResiduoPlanoEquipamento === eventGeneralData.idEventoReferencia2
          ) > -1
        ) {
          planoInicial = plano;
          for (const cotacao of planoInicial.cotacoes) {
            if (
              cotacao.equipamentos.findIndex(
                (x) => x.idPropostaResiduoPlanoEquipamento === eventGeneralData.idEventoReferencia2
              ) > -1
            ) {
              planoCotacaoInicial = cotacao;
              break;
            }
          }
        }
        if (planoInicial && planoCotacaoInicial) {
          break;
        }
      }
    } else if (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) {
      planoInicial =
        residuo.planos.find((x) => x.idPropostaResiduoPlano === eventGeneralData.idEventoReferencia2) ||
        (eventGeneralData.eventoReferenciaPersonalizado ? encontrarPlanoRegularBase(residuo) : null);
      planoCotacaoInicial = planoInicial?.cotacoes.find(
        (y: { idPropostaResiduoPlanoCotacao: number | null }) =>
          y.idPropostaResiduoPlanoCotacao === quotationId
      );
    }

    return { planoInicial, planoCotacaoInicial };
  };

  const montarDocumento = useMemo(() => {
    const entidade = evento!;
    const documento = evento?.referencia?.entidade?.documento;

    if (!documento) {
      return <></>;
    }

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={6}>
          <Grid.Col span={2}>
            {entidade!.CNPJ ? (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={entidade.idEntidade?.toString() || ''}
                    name={entidade.nomeFantasia || entidade.razaoSocial || '-'}
                    nameSize="sm"
                    description={entidade!.nomeFantasia ? entidade!.razaoSocial : entidade!.CNPJ}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            ) : (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={entidade.idEntidade?.toString() || ''}
                    name={entidade.nome || '-'}
                    nameSize="sm"
                    description={entidade!.CPF}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            )}
          </Grid.Col>
          <Grid.Col span={2}>
            <PageViewProperty
              label="Documento"
              text={
                <ProfileCardLink
                  id={documento.idEntidadeDocumento?.toString() || '-1'}
                  name={documento?.documentoTipo || documento?.outroTipo || '-'}
                  nameSize="sm"
                  description={documento.numeroDocumento || documento.observacao}
                  descriptionSize="xs"
                  showLink={false}
                />
              }
              size="sm"
            />
          </Grid.Col>
        </Grid>
      </Paper>
    );
  }, [
    eventGeneralData.codigoEventoReferencia,
    eventGeneralData.idEventoReferencia2,
    eventGeneralData.propostaResiduoData,
    quotationId,
    statusSoftDisabled,
    evento,
  ]);

  const montarComissao = useMemo(() => {
    const comissao = evento?.referencia?.comissao;

    if (!comissao) {
      return <></>;
    }

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={6}>
          <Grid.Col span={2}>
            {comissao!.cnpj ? (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={comissao.idEntidade?.toString() || ''}
                    name={comissao.nomeFantasia || comissao.razaoSocial || '-'}
                    nameSize="sm"
                    description={comissao!.nomeFantasia ? comissao!.razaoSocial : comissao!.cnpj}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            ) : (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={comissao.idEntidade?.toString() || ''}
                    name={comissao.nome || '-'}
                    nameSize="sm"
                    description={comissao!.cpf}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            )}
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty
              label="Porcentagem"
              text={comissao?.porcentagem ? `${comissao.porcentagem}%` : '-'}
              size="sm"
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty
              label="Preço"
              text={comissao?.preco ? formatCurrency(comissao.preco || 0) : '-'}
              size="sm"
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty label="Ocorrências" text={comissao?.ocorrencia || '-'} size="sm" />
          </Grid.Col>
        </Grid>
      </Paper>
    );
  }, [
    eventGeneralData.codigoEventoReferencia,
    eventGeneralData.idEventoReferencia2,
    eventGeneralData.propostaServicoData,
    evento?.servico,
    eventGeneralData.eventoReferenciaPersonalizado,
    statusSoftDisabled,
    props.referenceData,
    props.zIndex,
  ]);

  const montarResiduo = useMemo(() => {
    const residuo = eventGeneralData.propostaResiduoData;
    if (!residuo) {
      return <></>;
    }

    const { planoInicial } = encontrarPlanoCotacao();

    if (
      eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
      eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
      eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano
    ) {
      const selectedPlanId =
        eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano
          ? eventGeneralData.idEventoReferencia2 ||
            encontrarPlanoRegularBase(residuo)?.idPropostaResiduoPlano ||
            null
          : planoInicial?.idPropostaResiduoPlano || null;

      return (
        <div>
          {autoImportedMissingSupplier && (
            <>
              <Alert color="yellow" variant="light" icon={<IconAlertTriangle size={16} />}>
                O plano selecionado possui cotação sem fornecedor. A referência foi importada como
                personalizada para permitir o preenchimento.
              </Alert>
              <Space h="sm" />
            </>
          )}
          <EventResidueReferenceEditor
            key={`event-residue-reference-editor-${
              eventGeneralData.idEventoReferencia2?.toString() || '-1'
            }-${eventGeneralData.eventoReferenciaPersonalizado ? 'custom' : 'linked'}-${
              evento?.automatico || statusSoftDisabled ? 'view' : 'edit'
            }`}
            ref={refResidueReferenceEditor}
            referenceData={props.referenceData}
            residue={residuo}
            event={evento}
            selectedPlanId={selectedPlanId}
            selectedQuotationId={quotationId}
            forceSingleCustomFlow={!!eventGeneralData.eventoReferenciaPersonalizado}
            disabled={evento?.automatico || statusSoftDisabled || false}
            statusSoftDisabled={statusSoftDisabled}
            zIndex={props.zIndex + 1}
          />
        </div>
      );
    }

    const getQuotationData = () => {
      return (
        planoInicial?.cotacoes
          ?.sort((a: any, b: any) => Number(a.primario ? 0 : 1) - Number(b.primario ? 0 : 1))
          ?.map((y: any) => {
            return {
              label: `Cotação #${y.idPropostaResiduoPlanoCotacao}`,
              value: y.idPropostaResiduoPlanoCotacao!.toString(),
              group: `Cotação ${y.primario ? 'Primária' : 'Alternativa'}`,
              extras: [
                y?.veiculo
                  ? {
                      icone: Feature.Reference.Vehicle.icon,
                      fornecedor:
                        y.veiculo?.fornecedorNomeFantasia ??
                        y.veiculo?.fornecedorRazaoSocial ??
                        y.veiculo?.fornecedorNome ??
                        '-',
                    }
                  : undefined,
                y?.tratamento
                  ? {
                      icone: Feature.Reference.Treatment.icon,
                      fornecedor:
                        y.tratamento?.fornecedorNomeFantasia ??
                        y.tratamento?.fornecedorRazaoSocial ??
                        y.tratamento?.fornecedorNome ??
                        '-',
                    }
                  : undefined,
                y?.destinoFinal
                  ? {
                      icone: Feature.Reference.Destination.icon,
                      fornecedor:
                        y.destinoFinal?.fornecedorNomeFantasia ??
                        y.destinoFinal?.fornecedorRazaoSocial ??
                        y.destinoFinal?.fornecedorNome ??
                        '-',
                    }
                  : undefined,
              ].filter((e) => e),
            };
          }) || []
      );
    };

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between" key={`group-${quotationId?.toString() || '-1'}`}>
          <Group>
            <ProfileCardLink
              id={residuo.idResiduo.toString()}
              name={residuo.residuoCliente}
              nameSize="md"
              description={`Código IBAMA: ${residuo.codigoIBAMA || '-'} | Perigoso: ${
                residuo.residuoClientePerigoso ? 'Sim' : 'Não'
              }`}
              descriptionSize="sm"
              linkPrefix="residues"
              showLink={false}
            />
            <Group>
              <Stack gap="xs">
                {residuo.estimativa && (
                  <Badge key={newGuid()} variant="outline" size="md" color={Feature.Home.Event.color}>
                    {`Estimativa: ${residuo.estimativa} ${residuo.estimativaUnidadeMedida1} / ${residuo.estimativaUnidadeMedida2}`}
                  </Badge>
                )}
                {residuo.minimoAceitavel ? (
                  <Badge key={newGuid()} variant="outline" size="md" color="orange">
                    {`Mínimo Aceitável: ${residuo.minimoAceitavel} ${residuo.minimoAceitavelUnidadeMedida1} / ${residuo.minimoAceitavelUnidadeMedida2}`}
                  </Badge>
                ) : (
                  <></>
                )}
              </Stack>
              <Stack gap="xs">
                {residuo.compra && (
                  <Badge key={newGuid()} variant="outline" size="md" color={Feature.Home.Event.color}>
                    Compra
                  </Badge>
                )}
                {residuo.cobrarTolerancia && (
                  <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
                    Cobrar Tolerâncias
                  </Badge>
                )}
              </Stack>
            </Group>
          </Group>
          {(eventGeneralData.codigoEventoReferencia as any) === ReferenciaCodigo.ContratoResiduoPlano &&
            eventGeneralData.idEventoReferencia2 &&
            !props.event && (
              <Select
                leftSection={<IconZoomMoney size={15} />}
                renderOption={({ option }) => {
                  const qItem = getQuotationData().find((x: any) => x.value === option.value);
                  return buildSelectQuotationItem(qItem as any);
                }}
                placeholder="Selecione..."
                // data={
                //   planoInicial?.cotacoes?.map((y) => {
                //     return {
                //       value: y.idPropostaResiduoPlanoCotacao.toString(),
                //       label: `Cotação #${y.idPropostaResiduoPlanoCotacao}`,
                //     };
                //   }) || []
                // }
                data={transformComboBoxGroupDataFromV5toV7(getQuotationData())}
                value={quotationId?.toString()}
                onChange={(value) => {
                  const nextQuotationId = value ? Number(value) : null;
                  setQuotationId(nextQuotationId);
                  setEventGeneralData({
                    ...eventGeneralData,
                    idEventoReferencia3: nextQuotationId,
                  });
                }}
                searchable
              />
            )}
        </Group>
        <Space h="sm" />

        <div key={`nodes-${quotationId?.toString() || '-1'}`} />
      </Paper>
    );
  }, [
    eventGeneralData.codigoEventoReferencia,
    eventGeneralData.idEventoReferencia2,
    eventGeneralData.propostaResiduoData,
    quotationId,
    statusSoftDisabled,
    evento,
  ]);

  const montarServico = useMemo(() => {
    const servico =
      eventGeneralData.propostaServicoData ||
      // evento?.servico ||
      // evento?.referencia?.contrato?.servico ||
      null;
    if (!servico) {
      return <></>;
    }

    let finalItem = evento?.servico || null;
    const selectedQuotation =
      servico.cotacoes?.find(
        (x) => Number(x.idPropostaServicoCotacao) === Number(eventGeneralData.idEventoReferencia3)
      ) ||
      servico.cotacoes?.find((x) => x.primario) ||
      servico.cotacoes?.[0] ||
      null;

    if (!finalItem) {
      if (!eventGeneralData.eventoReferenciaPersonalizado) {
        finalItem = {
          ...buildFakeAuditObject(),
          ...servico,
          cotacao: { ...selectedQuotation },
        };
      } else {
        finalItem = {
          ...buildFakeAuditObject(),
          ...servico,
          cotacao: selectedQuotation ? { ...selectedQuotation } : {},
        };
      }
    }

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between" key={`group-${quotationId?.toString() || '-1'}`}>
          <Group>
            <ProfileCardLink
              id={servico.idServico.toString()}
              name={servico.servico}
              nameSize="md"
              description={servico.servicoDescricao}
              descriptionSize="sm"
              linkPrefix="services"
              showLink={false}
            />
            <Badge key={newGuid()} variant="outline" size="md" color={Feature.Home.Event.color}>
              {`${servico.residuoAcondicionamento || servico.residuoEquipamento || 'Fornecedor'}`}
            </Badge>
          </Group>
        </Group>
        <Space h="sm" />

        <EventServiceFormView
          key={`service-${
            eventGeneralData.eventoReferenciaPersonalizado
              ? '-1'
              : eventGeneralData.idEventoReferencia1?.toString()
          }`}
          ref={refServiceForm}
          origItem={evento?.servico || null}
          item={finalItem}
          referenceData={props.referenceData}
          quotations={eventGeneralData.eventoReferenciaPersonalizado ? [] : servico.cotacoes || []}
          disabled={evento?.automatico || statusSoftDisabled || false}
          zIndex={props.zIndex + 1}
        />
      </Paper>
    );
  }, [
    eventGeneralData.codigoEventoReferencia,
    eventGeneralData.idEventoReferencia2,
    eventGeneralData.propostaServicoData,
    eventGeneralData.eventoReferenciaPersonalizado,
    quotationId,
    statusSoftDisabled,
    evento?.servico,
    evento?.referencia?.contrato?.servico,
    evento?.automatico,
    props.referenceData,
    props.zIndex,
  ]);

  useImperativeHandle(ref, () => ({
    validate() {
      try {
        let response = {};

        if (
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
          eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano
        ) {
          return { ...response, ...refResidueReferenceEditor.current.validate() };
        }

        if (eventGeneralData.codigoEventoReferencia === ReferenciaCodigo.ContratoServico) {
          response = { ...response, ...refServiceForm.current.validate() };
        }

        return response;
      } catch (ex: any) {
        throw Error(ex.message || 'Existem pendências a serem corrigidas.');
      }
    },
  }));

  useEffect(() => {
    const { planoInicial } = encontrarPlanoCotacao();
    if (!planoInicial) {
      return;
    }

    const currentQuotationStillExists =
      planoInicial?.cotacoes?.some(
        (cotacao: any) => Number(cotacao.idPropostaResiduoPlanoCotacao) === Number(quotationId)
      ) || false;

    setQuotationId(
      (eventGeneralData.idEventoReferencia3 &&
      planoInicial?.cotacoes?.some(
        (cotacao: any) =>
          Number(cotacao.idPropostaResiduoPlanoCotacao) === Number(eventGeneralData.idEventoReferencia3)
      )
        ? Number(eventGeneralData.idEventoReferencia3)
        : null) ||
        (currentQuotationStillExists
          ? quotationId
          : planoInicial?.cotacoes?.find((x: any) => x.primario)?.idPropostaResiduoPlanoCotacao ||
            planoInicial?.cotacoes?.[0]?.idPropostaResiduoPlanoCotacao ||
            null)
    );
  }, [eventGeneralData, quotationId]);

  return (
    <div>
      {clienteLocalValido() && (
        <>
          <Paper shadow="xs" p="md" withBorder>
            <PageSection
              size="lg"
              color={Feature.Home.Event.color}
              label="Cliente e Local"
              text="Cliente e local onde a prestação de serviço deverá ocorrer."
            />
            <Space h="xs" />

            <Grid columns={6}>
              <Grid.Col span={2}>
                {clienteLocalData!.clienteCNPJ ? (
                  <ProfileCardLink
                    id={clienteLocalData!.idCliente?.toString() || ''}
                    name={
                      clienteLocalData!.clienteNomeFantasia || clienteLocalData!.clienteRazaoSocial || '-'
                    }
                    nameSize="sm"
                    description={
                      clienteLocalData!.clienteNomeFantasia
                        ? clienteLocalData!.clienteRazaoSocial
                        : clienteLocalData!.clienteCNPJ
                    }
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                ) : (
                  <ProfileCardLink
                    id={clienteLocalData!.idCliente?.toString() || ''}
                    name={clienteLocalData!.clienteNome || '-'}
                    nameSize="sm"
                    description={clienteLocalData!.clienteCPF}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                )}
              </Grid.Col>
              {propostaContato && (
                <Grid.Col span={2}>
                  <ProfileCardLink
                    id={propostaContato?.idEntidadeContato.toString() || '-1'}
                    name={propostaContato?.nome || '-'}
                    nameSize="sm"
                    description={
                      propostaContato?.telefone ||
                      propostaContato?.celular ||
                      propostaContato?.email ||
                      propostaContato?.setor
                    }
                    descriptionSize="xs"
                    showLink={false}
                  />
                </Grid.Col>
              )}
            </Grid>
            <Divider my="sm" />

            <Grid columns={6}>
              <Grid.Col span={2}>
                <PageViewProperty
                  label="Logradouro"
                  text={`${clienteLocalData!.logradouro}, ${clienteLocalData!.numero}${
                    clienteLocalData!.complemento ? ` | ${clienteLocalData!.complemento}` : ''
                  }`}
                  size="sm"
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <PageViewProperty
                  label="Bairro - Cidade"
                  text={`${clienteLocalData!.bairro} - ${clienteLocalData!.cidade} / ${
                    clienteLocalData!.codigoEstado
                  }`}
                  size="sm"
                />
              </Grid.Col>
              <Grid.Col span={1}>
                <PageViewProperty label="CEP" text={clienteLocalData!.cep} size="sm" />
              </Grid.Col>
            </Grid>
          </Paper>
          <Space h="lg" />
        </>
      )}

      <Paper shadow="xs" p="md" withBorder>
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label={eventGeneralData.eventoTipo || 'Referência'}
          text="Informações detalhadas do evento como resíduo, serviço, documento, cliente, local, fornecedores, etc."
        />
        <Space h="xs" />

        {residuoValido() && montarResiduo}
        {servicoValido() && montarServico}
        {documentoValido() && montarDocumento}
        {comissaoValida() && montarComissao}
      </Paper>
    </div>
  );
});

export default ReferenceFormView;
